import React from 'react'
import { Helmet } from "react-helmet";
import ContactDetails from '../../components/Contact/ContactDetails'

const Contact = () => {
  return (
    <div>
      <Helmet>
  {/* Google Analytics Tag */}
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16818142902');
    `}
  </script>

  {/* Basic Meta */}
  <title>Contact Us | Aptech Lekki Centre - Get In Touch With Us</title>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  
  <meta
    name="description"
    content="Have questions about our IT training programs? Contact Aptech Lekki Centre today. Visit our Lekki campus, call, or email us to learn more about enrolling for software development, data analytics, project management, and digital marketing courses."
  />
  
  <meta
    name="keywords"
    content="Contact Aptech Lekki, Contact IT training Lekki, Contact software development school Nigeria, IT certification inquiry Lekki, Call Aptech Lekki Centre, Get in touch Aptech Lekki, Web development training contact Lekki, Coding bootcamp inquiry Lagos"
  />
  
  <meta name="author" content="Aptech Lekki Centre" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://aptechlekki.com/contact" />

  {/* Open Graph Meta for Social Media */}
  <meta property="og:title" content="Contact Us | Aptech Lekki Centre" />
  <meta property="og:description" content="Get in touch with Aptech Lekki Centre. Reach out to us for IT course information, enrollment support, and campus visits." />
  <meta property="og:url" content="https://aptechlekki.com/contact" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://aptechlekki.com/assets/og_image.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Contact Us | Aptech Lekki Centre" />
  <meta name="twitter:description" content="Reach Aptech Lekki Centre for IT training inquiries, course applications, and general support." />
  <meta name="twitter:image" content="https://aptechlekki.com/assets/og_image.jpg" />
</Helmet>

      <ContactDetails />
    </div>
  )
}

export default Contact